import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import HeaderTitle from '../components/HeaderTitle'
import SEO from '../components/Seo'
import ButtonPrimary from '../components/ButtonPrimary'
import ContentBlock from '../components/ContentBlock'

import { Colors, Sizes, FontRegular, FontLight, Breakpoints } from './../utils/variables'

import heroBackground from './../images/hero-bg.jpg'

import styled from 'styled-components'

export const Hero = styled.div`
	position: relative;

	width: 100%;

	// margin-bottom: 60px;
	padding: 30px;

	text-align: right;

	&:before {
		content: '';
		position: absolute;
		
		left: 0;
		bottom: 100px;
		z-index: 0;
		
		width: 100%;
		height: 100%;

		background-image: url(${heroBackground});
		background-size: cover;
		background-position: center;
	}

	@media screen and (min-width: ${Breakpoints.wide}) {		
		margin-bottom: 100px;
		padding: 0;

		&:before {
			bottom: 0;
		}
	}
`

export const Wrapper = styled.div`
	display: block;
	position: relative;
	
	padding: 30px;

	background-color: ${Colors.white};

	text-align: left;

	@media screen and (min-width: ${Breakpoints.wide}) {
		display: inline-block;

		width: 750px;

		margin-right: 260px;
		padding: 100px;
	}
`

export const Subheader = styled.span`
	display: block;

	margin-bottom: 15px;

	${FontRegular}
	font-size: 10px;
	line-height: 15px;
	letter-spacing: 1px;
	
	color: ${Colors.black};
	opacity: 0.5;

	text-transform: uppercase;

	@media screen and (min-width: ${Breakpoints.wide}) {
		margin-bottom: 15px;

		font-size: 13px;
		letter-spacing: 2px;
	}
`

export const StyledContent = styled.div`
	h2 {
		margin-bottom: 15px;

		${FontRegular}
		font-size: 16px;
		line-height: 23px;
	}

	p {
		margin-bottom: 15px;

		${FontLight}
		font-size: 13px;
		line-height: 20px;
	}

	@media screen and (min-width: ${Breakpoints.wide}) {
		h2 {
			font-size: 20px;
			line-height: 30px;
		}

		p {
			margin-bottom: 25px;
			
			font-size: 14px;
			line-height: 24px;
		}
	}
`

export const Content = styled.div`
	width: 100%;
	overflow: scroll;

	margin-bottom: 80px;
	background-color: transparent;

	@media screen and (min-width: ${Breakpoints.wide}) {
		margin-bottom: 100px;

		background-color: ${Colors.white};
	}
`

export const Image = styled.img`
	display: block;
	
	max-width: 800px;

	padding: 0 30px;
	border: none;

	@media screen and (min-width: ${Breakpoints.wide}) {
		width: 100%;
		max-width: ${Sizes.maxContainerWidth};
	
		margin: 0 auto;
		padding: 0;
	}
`

const IndexPage = ({ data: { prismicHome } }) => (
	<Layout theme='light' page='home'>
		
		<SEO title={prismicHome.data.header_title.text} />

		<Hero>

			<HeaderTitle label={prismicHome.data.header_title.text} theme='light' page='home'/>

			<Wrapper>
				<Subheader>001 Introduction</Subheader>
				<StyledContent dangerouslySetInnerHTML={{
					__html: prismicHome.data.introduction_title.html
				}} />
				<StyledContent dangerouslySetInnerHTML={{
					__html: prismicHome.data.introduction_text.html
				}} />
				<ButtonPrimary url={prismicHome.data.link.text} label='Learn More'/>
			</Wrapper>

		</Hero>

		<ContentBlock data={prismicHome.data.content.html} />

		
	</Layout>
)

export default IndexPage

export const pageQuery = graphql`
	query IndexQuery {
		prismicHome {
			data {
				header_title {
					text
				}
				introduction_title {
					html
				}
				introduction_text {
					html
				}
				content {
					html
				}
				link {
					text
				}
			}
		}
	}
`